var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83333 2.60302C6.83333 1.99384 7.32719 1.5 7.93633 1.5H8C9.01255 1.5 9.83333 2.32082 9.83333 3.33333V6.16667H12.5093C13.8721 6.16667 14.7586 7.60087 14.1491 8.81987L11.8157 13.4865C11.5052 14.1077 10.8704 14.5 10.1759 14.5H7.49747C7.34748 14.5 7.19823 14.4816 7.05301 14.4453L4.60511 13.8333H3.33333C2.32082 13.8333 1.5 13.0125 1.5 12V8C1.5 6.98745 2.32082 6.16667 3.33333 6.16667H4.84351L6.51217 3.66365C6.72159 3.34958 6.83333 2.98052 6.83333 2.60302ZM4.19526 7.16667H3.33333C2.87309 7.16667 2.5 7.53975 2.5 8V12C2.5 12.4603 2.87309 12.8333 3.33333 12.8333H4.16667V7.33333C4.16667 7.27626 4.17644 7.21992 4.19526 7.16667ZM5.16667 12.9429L7.29512 13.4751C7.3615 13.4916 7.42945 13.5 7.49747 13.5H10.1759C10.4916 13.5 10.7801 13.3217 10.9213 13.0393L13.2547 8.37266C13.5317 7.81859 13.1288 7.16667 12.5093 7.16667H8C7.72386 7.16667 7.5 6.94281 7.5 6.66667C7.5 6.39052 7.72386 6.16667 8 6.16667H8.83333V3.33333C8.83333 2.87309 8.46025 2.5 8 2.5H7.93633C7.87948 2.5 7.83333 2.54612 7.83333 2.60302C7.83333 3.17792 7.66319 3.73999 7.3442 4.21838L5.16667 7.48472V12.9429Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumbUp.01245d1c.svg";
export { ForwardRef as ReactComponent };